/**
 * routes.js — registry of SEO/landing pages (path + <head> meta + Component).
 *
 * The page COPY for <head> (path/title/description/priority) lives in the
 * dependency-free pages.js so the Node build-time prerender + sitemap generator
 * can read it too; the page BODIES live in site/content/pages.js and render
 * through the three website templates (site/pages/Templates.jsx: /for landing,
 * /vs comparison, product). This file only wires each path to its component.
 *
 * LOADERS (path → dynamic import resolving to { default: Component }) is the
 * single source of truth. Two consumers derive from it:
 *   • COMPONENTS — React.lazy() wrappers, so none of these pages ship in the
 *     homepage bundle.
 *   • routeComponents.js — awaits a loader to register the page eagerly, which
 *     is how the build-time prerender renders real markup and how the browser
 *     avoids a Suspense fallback that would not match the prerendered HTML.
 */
import { lazy } from 'react';
import { MARKETING_PAGES } from './pages.js';

const tpl = (path) => () => import('../../site/pages/Templates.jsx').then((m) => ({ default: m.PAGES[path] }));

export const LOADERS = Object.fromEntries(MARKETING_PAGES.map((p) => [p.path, tpl(p.path)]));

const COMPONENTS = Object.fromEntries(
  Object.entries(LOADERS).map(([path, load]) => [path, lazy(load)])
);

export const MARKETING_ROUTES = MARKETING_PAGES.map((p) => ({ ...p, Component: COMPONENTS[p.path] }));

// path → route lookup
export const MARKETING_BY_PATH = Object.fromEntries(MARKETING_ROUTES.map((r) => [r.path, r]));
